module.exports = __webpack_public_path__ + "media/flags/hu-9f419826.svg";